<template>
  <app-responsive />
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppResponsive from '@/components/AppResponsive.vue'

export default defineComponent({
  components: { AppResponsive },
})
</script>
